// extracted by mini-css-extract-plugin
export default {"MainModal":"MainModal_MainModal__PDQwC","drawer":"MainModal_drawer__p6QjH"};